import {CmsContent} from "../../Model/CmsContent/CmsContent";
import {ApplicationContext} from "../../ApplicationContext";
import * as React from "react";
import {Navigate} from "react-router-dom";
import {SALES_PORTAL_ROUTES} from "../../Routes/SalesPortalRoutes";
import SuperdrugRafPage from "./SuperdrugRafPage";
import {COUNTER_PAGE_LOAD} from "../../Service/CounterMetricsProvider";

interface RafPageProps {
    /**
     * Array of all content currently stored in the CMS that has been made available to the Sales Portal.
     */
    readonly cmsContent: CmsContent[]
}

const RafPage = (props: RafPageProps): JSX.Element => {
    const applicationContext = React.useContext(ApplicationContext)

    React.useEffect(() => {
        window.scrollTo(0, 0)
        COUNTER_PAGE_LOAD.emit({
            severityNumber: 9,
            severityText: "INFO",
            body: "",
            attributes: {"page": "/RAF/{referralCode}"}
        });
    }, [])

    if (applicationContext.reseller === "superdrug") {
        return <SuperdrugRafPage cmsContent={props.cmsContent}/>
    } else {
        return <Navigate to={SALES_PORTAL_ROUTES.NotFound(applicationContext.urlContext)}/>
    }
}

export interface RafData {
    referralCode: string,
    referralCustomerRef: string
}

export const sessionStorageRafKey = "rafData"

export default RafPage